import base from './baseOptions';
import buildDrillDown from '../../../buildDrillDown';
import { ChartColors } from '../../../theme/tokens';

// Sankey plots flow between two dimensions: dimensionA members are source nodes,
// dimensionB members are target nodes, and the metric is the link weight. Reuses
// the two-dimension metric-matrix pipeline. Requires the sankey module
// (registered in Chart.tsx). Node ids are prefixed in the data hook so that a
// value shared between the two dimensions doesn't collapse into one node.
const sankey = ({
  formatMetric,
  title,
  metricId,
  fontSize,
  openMenu,
  groupField,
  fieldType,
  chartDef,
}) => ({
  ...base(formatMetric),
  chart: {
    ...base(formatMetric).chart,
    type: 'sankey',
  },
  // Sankey is non-cartesian but still declares x/y axisTypes, so it needs an
  // axis to exist. baseOptions sets xAxis/yAxis to empty arrays (suppressing
  // the defaults), which triggers Highcharts error #18 — provide hidden axes.
  xAxis: { visible: false },
  yAxis: { visible: false },
  title: {
    ...base(formatMetric).title,
    text: title,
  },
  legend: {
    ...base(formatMetric).legend,
    enabled: false,
  },
  plotOptions: {
    sankey: {
      colors: ChartColors,
      nodePadding: 8,
      dataLabels: {
        enabled: true,
        style: {
          color: 'var(--color-text-primary)',
          textOutline: 'none',
          fontWeight: 'normal',
          fontSize,
        },
      },
      point: {
        events: {
          click: function () {
            // Only source (dimensionA) nodes drill down.
            if (!this.isNode || this.column !== 0) {
              return;
            }
            const term = this.name;
            if (openMenu) {
              const { metricIds } = this.series.userOptions;
              openMenu(
                metricIds,
                buildDrillDown(groupField, fieldType, term, chartDef),
              );
            } else {
              const { onDrillDown } = this.series.userOptions;
              if (onDrillDown) {
                onDrillDown(term);
              }
            }
          },
        },
      },
    },
  },
  tooltip: {
    ...base(formatMetric).tooltip,
    shared: false,
    useHTML: true,
    nodeFormatter: function () {
      const value = formatMetric({ metricId, value: this.sum });
      return `<b>${this.name}</b>: ${value}`;
    },
    pointFormatter: function () {
      const value = formatMetric({ metricId, value: this.weight });
      return `<b>${this.fromNode.name} → ${this.toNode.name}</b>: ${value}`;
    },
  },
});

export default sankey;
